/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * Audius V1 API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Activity } from './Activity';
import {
    ActivityFromJSON,
    ActivityFromJSONTyped,
    ActivityToJSON,
} from './Activity';

/**
 * 
 * @export
 * @interface Reposts
 */
export interface Reposts {
    /**
     * 
     * @type {Array<Activity>}
     * @memberof Reposts
     */
    data?: Array<Activity>;
}

/**
 * Check if a given object implements the Reposts interface.
 */
export function instanceOfReposts(value: object): value is Reposts {
    let isInstance = true;

    return isInstance;
}

export function RepostsFromJSON(json: any): Reposts {
    return RepostsFromJSONTyped(json, false);
}

export function RepostsFromJSONTyped(json: any, ignoreDiscriminator: boolean): Reposts {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(ActivityFromJSON)),
    };
}

export function RepostsToJSON(value?: Reposts | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(ActivityToJSON)),
    };
}

